import { render, staticRenderFns } from "./Double11SuccessDialog.vue?vue&type=template&id=383acb86&scoped=true"
import script from "./Double11SuccessDialog.vue?vue&type=script&lang=js"
export * from "./Double11SuccessDialog.vue?vue&type=script&lang=js"
import style0 from "./Double11SuccessDialog.vue?vue&type=style&index=0&id=383acb86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383acb86",
  null
  
)

export default component.exports